document.addEventListener('DOMContentLoaded', function() {
  initMobileMenu();
  initFAQ();
  initSmoothScroll();
  initStampAnimation();
  initCarousel();
});

function initMobileMenu() {
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function() {
      mobileNav.classList.toggle('active');
    });
  }
}

function initFAQ() {
  const faqQuestions = document.querySelectorAll('.faq-question');
  const faqItems = document.querySelectorAll('.faq-item');

  // Open the first FAQ item by default
  if (faqItems.length > 0) {
    faqItems[0].classList.add('active');
  }

  faqQuestions.forEach(function(question) {
    question.addEventListener('click', function() {
      const faqItem = this.closest('.faq-item');
      const isActive = faqItem.classList.contains('active');

      document.querySelectorAll('.faq-item').forEach(function(item) {
        item.classList.remove('active');
      });

      if (!isActive) {
        faqItem.classList.add('active');
      }
    });
  });
}

function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');

      if (href === '#' || href === '') return;

      const target = document.querySelector(href);

      if (target) {
        e.preventDefault();

        const headerOffset = 80;
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
}

function initStampAnimation() {
  const stampElements = document.querySelectorAll('.brackets-stamp');
  if (!stampElements.length) return;

  const stampedElements = new Set();

  function checkStamp() {
    stampElements.forEach(function(stampElement) {
      if (stampedElements.has(stampElement)) return;

      const rect = stampElement.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const triggerPoint = windowHeight * 0.7;

      if (rect.top < triggerPoint && rect.bottom > 0) {
        stampElement.classList.add('stamp-animate');
        stampedElements.add(stampElement);
      }
    });
  }

  window.addEventListener('scroll', checkStamp);
  checkStamp();
}

function initCarousel() {
  const carousel = document.querySelector('.product-carousel');
  if (!carousel) return;

  const images = carousel.querySelectorAll('.carousel-image');
  const dots = carousel.querySelectorAll('.carousel-dot');
  let currentIndex = 0;
  let autoplayInterval;

  function showImage(index) {
    images.forEach(function(img, i) {
      if (i === index) {
        img.classList.add('active');
      } else {
        img.classList.remove('active');
      }
    });

    dots.forEach(function(dot, i) {
      if (i === index) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });

    currentIndex = index;
  }

  function nextImage() {
    const nextIndex = (currentIndex + 1) % images.length;
    showImage(nextIndex);
  }

  function startAutoplay() {
    const isMobile = window.innerWidth <= 640;
    const interval = isMobile ? 3000 : 5000;
    autoplayInterval = setInterval(nextImage, interval);
  }

  function stopAutoplay() {
    clearInterval(autoplayInterval);
  }

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      const index = parseInt(this.getAttribute('data-index'));
      showImage(index);
      stopAutoplay();
      startAutoplay();
    });
  });

  startAutoplay();

  carousel.addEventListener('mouseenter', stopAutoplay);
  carousel.addEventListener('mouseleave', startAutoplay);
}
